import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "./AppHeader.scss";

// cora web components
import Autocomplete from "../../coraWebComponents/forms/Autocomplete";
import DropDownList from "../../coraWebComponents/forms/DropDownList";
import LoadingPanel from "../../coraWebComponents/LoadingPanel";
import ComponentTitle from "../../components/ComponentTitle";

// prop types
import odberatelPropTypes from "../../propTypes/odberatelPropTypes";
import odberneMiestaPropTypes from "../../propTypes/odberneMiestaPropTypes";
import zmluvyPropTypes from "../../propTypes/zmluvyPropTypes";

// actions
import * as appHeaderActions from "../../actions/appHeaderActions";
import * as odberatelActions from "../../actions/odberatel/odberatelActions";
import * as odberneMiestaActions from "../../actions/odberneMiesta/odberneMiestaActions";
import * as zmluvyActions from "../../actions/zmluvy/zmluvyActions";

class AppHeader extends React.Component {
  // DROP DOWN - OM PROPS
  onChangeOMHandle = async (name, OM) => {
    const data = this.buildChangeOMData(OM);
    await this.props.changeOM(data);
  };

  // AUTOCOMPLETE - ODBERATEL PROPS
  onChangeOdberatel = async (filter, sort, page) => {
    await this.props.getListOdberatelHeader(this.buildFilter(filter));
  };
  onFilterOdberatel = async (filter) => {
    const NAZOV = this.getValueByColName(filter, "NAZOV");
    const I_ORGAN = null;

    const data = this.buildChangeOdberatelData({ NAZOV, I_ORGAN });
    await this.props.changeOdberatel(data);
  };
  onSelectOdberatel = async (odberatel, name, event) => {
    if (odberatel) {
      const data = this.buildChangeOdberatelData(odberatel);
      await this.props.changeOdberatel(data);
    }
  };

  // AUTOCOMPLETE - ZMLUVA PROPS
  onChangeZmluvaAuto = async (filter, sort, page) => {
    const { customFiltersZmluvy, getListZmluvaHeader } = this.props;

    const filters = [...filter.filters, ...customFiltersZmluvy];
    await getListZmluvaHeader({ filters });
  };
  onFilterZmluvaAuto = async (filter) => {
    const C_ZMLUVY = this.getValueByColName(filter, "C_ZMLUVY");
    const I_ZMLUVY = null;

    const data = { zmluva: { I_ZMLUVY, C_ZMLUVY } };
    await this.props.changeZmluva(data);
  };
  onSelectZmluvaAuto = async (zmluva) => {
    if (zmluva) {
      const data = this.buildChangeZmluvaData(zmluva);
      await this.props.changeZmluva(data);
    }
  };

  // METHODS
  setFirstOdberatel = async () => {
    const { changeOdberatel, listOdberatelHeader } = this.props;

    let odberatel = null;
    if (listOdberatelHeader?.length === 1) {
      odberatel = listOdberatelHeader[0];
    } else {
      odberatel = { NAZOV: "", I_ORGAN: null };
    }

    const data = this.buildChangeOdberatelData(odberatel);
    await changeOdberatel(data);
  };
  buildGridsProps = () => {
    const {
      gridFilterOdberatel,
      gridPageOdberatel,
      gridSortOdberatel,

      gridFilterZmluvy,
      gridPageZmluvy,
      gridSortZmluvy,

      gridFilterOM,
      gridPageOM,
      gridSortOM,

      gridFilterFaktura,
      gridSortFaktura,
      gridPageFaktura,
    } = this.props;

    return {
      odberatel: {
        gridFilter: this.buildFilter(gridFilterOdberatel),
        gridSort: gridSortOdberatel,
        gridPage: gridPageOdberatel,
      },
      zmluvy: {
        gridFilter: gridFilterZmluvy,
        gridSort: gridSortZmluvy,
        gridPage: gridPageZmluvy,
      },
      OM: {
        gridFilter: gridFilterOM,
        gridSort: gridSortOM,
        gridPage: gridPageOM,
      },
      faktury: {
        gridFilter: gridFilterFaktura,
        gridSort: gridSortFaktura,
        gridPage: gridPageFaktura,
      },
    };
  };
  buildChangeOdberatelData = (odberatel) => {
    const grids = this.buildGridsProps();

    return {
      odberatel,
      grids,
    };
  };
  buildChangeZmluvaData = (zmluva) => {
    const grids = this.buildGridsProps();

    return {
      zmluva,
      grids,
    };
  };
  buildChangeOMData = (OM) => {
    const grids = this.buildGridsProps();

    return {
      OM,
      grids,
    };
  };
  getValueByColName = (filter, colName) => {
    const found = filter.filters.find((f) => f.field === colName);
    return found === undefined ? "" : found.value;
  };

  buildFilter = (filter) => {
    const { userOrgansIDs, isUserAdmin } = this.props;
    const filters = [...filter.filters.filter(x => x.field !== "I_ORGAN")];
    if (!isUserAdmin) {
      filters.push({ field: "I_ORGAN", operator: "in", value: userOrgansIDs.join() });
    }
    return { filters };
  };

  // SYSTEM METHODS
  componentDidMount = async () => {
    const { getListOdberatelHeader } = this.props;
    await getListOdberatelHeader(this.buildFilter({ filters: [] }));
    await this.setFirstOdberatel();
  };
  render() {
    const {
      header,
      listOdberatelHeader,
      listOMHeader,
      listZmluvaHeader,
      isLoading,
      isZmluvaPicked,
      odberatel,
      odberneMiesto,
      zmluva,
      isOdberatelPicked,
    } = this.props;

    return (
      <>
        {(header.title || header.show) && (
          <div className="row m-0">
            <div className="col p-0">
              <div className="appHeader">
                {header.title && <ComponentTitle text={header.title} />}
                {header.show && (
                  <div className="row m-0">
                    {odberatel && (
                      <p className="label">
                        Odberateľ:
                        <Autocomplete
                          className={`basicwhiteBackground ${isOdberatelPicked ? "fontWeightBold" : ""}`}
                          primaryField="I_ORGAN"
                          selected={odberatel}
                          validationMessage="Povinné"
                          textField="NAZOV"
                          textFilter={odberatel.NAZOV}
                          onChange={this.onChangeOdberatel}
                          onFilter={this.onFilterOdberatel}
                          data={listOdberatelHeader}
                          isLoading={isLoading}
                          onSelect={this.onSelectOdberatel}
                          placeholder="Napíšte meno"
                          onFocus={(e) => e.target.setState({ opened: true })}
                        />
                      </p>
                    )}

                    {zmluva && (
                      <p className="label">
                        Číslo zmluvy:
                        <Autocomplete
                          className={`autocompleteZmluvy basicwhiteBackground ${isZmluvaPicked ? "fontWeightBold" : ""}`}
                          disabled={!isOdberatelPicked}
                          primaryField="I_ZMLUVY"
                          selected={zmluva}
                          validationMessage="Povinné"
                          textField="C_ZMLUVY"
                          textFilter={zmluva.C_ZMLUVY}
                          onChange={this.onChangeZmluvaAuto}
                          onFilter={this.onFilterZmluvaAuto}
                          data={listZmluvaHeader}
                          isLoading={isLoading}
                          onSelect={this.onSelectZmluvaAuto}
                          placeholder="Napíšte názov"
                          onFocus={(e) => e.target.setState({ opened: true })}
                        />
                      </p>
                    )}

                    <p className="label">
                      Odberné miesto:
                      <DropDownList
                        className={isZmluvaPicked ? "basicwhiteBackground fontWeightBold" : "secondarylightBackground"}
                        disabled={!isZmluvaPicked}
                        value={odberneMiesto}
                        name="Odberné miesto"
                        validationMessage="Povinné"
                        textField="NAZOV"
                        onChange={this.onChangeOMHandle}
                        required={true}
                        data={
                          isZmluvaPicked ? listOMHeader : [{ ...odberneMiesto }]
                        }
                      />
                    </p>
                  </div>
                )}

                <LoadingPanel isLoading={isLoading} />
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    header: state.header.data,
    isLoading:
      state.headerListZmluva.isLoading ||
      state.headerListOM.isLoading ||
      state.headerListOdberatel.isLoading,

    // USER
    isUserAdmin: state.user.data.Uzivatel.L_ADMIN,
    userOrgansIDs: state.user.data.Uzivatel.I_ORGANS,

    // ODBERATEL
    isOdberatelPicked: state.odberatel.isPicked,
    odberatel: state.odberatel.data,

    // ODBERATEL HEADER
    listOdberatelHeader: state.headerListOdberatel.data,

    // ODBERATEL GRID
    gridFilterOdberatel: state.listOdberatel.gridFilter,
    gridSortOdberatel: state.listOdberatel.gridSort,
    gridPageOdberatel: state.listOdberatel.gridPage,

    // ZMLUVA
    isZmluvaPicked: state.zmluva.isPicked,
    zmluva: state.zmluva.data,

    // ZMLUVY HEADER
    listZmluvaHeader: state.headerListZmluva.data,

    // ZMLUVY GRID
    customFiltersZmluvy: state.listZmluva.customFilters,
    gridFilterZmluvy: state.listZmluva.gridFilter,
    gridSortZmluvy: state.listZmluva.gridSort,
    gridPageZmluvy: state.listZmluva.gridPage,

    // OM
    isOMPicked: state.OM.isPicked,
    odberneMiesto: state.OM.data,

    // OM HEADER
    listOMHeader: state.headerListOM.data,

    // OM GRID
    gridFilterOM: state.listOM.gridFilter,
    gridSortOM: state.listOM.gridSort,
    gridPageOM: state.listOM.gridPage,

    // FAKTURY GRID
    gridFilterFaktura: state.listFaktura.gridFilter,
    gridSortFaktura: state.listFaktura.gridSort,
    gridPageFaktura: state.listFaktura.gridPage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  changeOdberatel: async (data) => await dispatch(odberatelActions.changeOdberatel(data)),
  changeOM: (value) => dispatch(odberneMiestaActions.changeOM(value)),
  changeZmluva: async (data) => await dispatch(zmluvyActions.changeZmluva(data)),
  getListOdberatelHeader: async (filter) => await dispatch(appHeaderActions.getListOdberatelHeader(filter, [], { skip: 0, take: 20 })),
  getListZmluvaHeader: async (filter) => await dispatch(appHeaderActions.getListZmluvaHeader(filter, [], { skip: 0, take: 20 })),
});

AppHeader.propTypes = {
  customFiltersZmluvy: PropTypes.arrayOf(PropTypes.object),
  getListOdberatelHeader: PropTypes.func,
  getListSpravaCurrentUser: PropTypes.func,
  getListZmluvaHeader: PropTypes.func,
  header: PropTypes.shape({
    data: PropTypes.shape({
      show: PropTypes.bool,
      title: PropTypes.string,
    }),
  }),
  changeOdberatel: PropTypes.func,
  changeOM: PropTypes.func,
  changeZmluva: PropTypes.func,
  isLoading: PropTypes.bool,
  isOdberatelPicked: PropTypes.bool,
  isOMPicked: PropTypes.bool,
  isUserAdmin: PropTypes.bool,
  isZmluvaPicked: PropTypes.bool,
  listOdberatelHeader: PropTypes.arrayOf(odberatelPropTypes.odberatel),
  listOMHeader: PropTypes.arrayOf(odberneMiestaPropTypes.odberneMiesto),
  listZmluvaHeader: PropTypes.arrayOf(zmluvyPropTypes.zmluva),
  odberatel: odberatelPropTypes.odberatel,
  odberneMiesto: odberneMiestaPropTypes.odberneMiesto,
  userOrgansIDs: PropTypes.array,
  zmluva: zmluvyPropTypes.zmluva,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);
